import { render, staticRenderFns } from "./BnftSrvRcrdApp.vue?vue&type=template&id=21cdb286&"
import script from "./BnftSrvRcrdApp.vue?vue&type=script&lang=js&"
export * from "./BnftSrvRcrdApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports